/**
 * Swiperのオプションを生成する関数。
 * カスタムオプションでデフォルトオプションを上書きする。
 *
 * @param {Object} customOptions - Swiperに適用するカスタムオプション。
 * @param {Object|null} newDefaultOptions - 新しいデフォルトオプション。指定されない場合は、内部で定義されたデフォルトオプションが使用される。
 * @returns {Object} - 結合されたSwiperオプション。
 */
export const swiperOptions = (customOptions = {}, newDefaultOptions = null) => {
  const defaultOptions = newDefaultOptions || {
    loop: true,
    autoplay: {
      delay: 5000,
    },
    speed: 3000,
  };

  return {
    ...defaultOptions,
    ...customOptions,
    autoplay: {
      ...defaultOptions.autoplay,
      ...customOptions.autoplay
    }
  };
};
